import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text as StyledText } from './FontStyles';

interface Props {
    white?: boolean,
    style?: {},
    children?: any,
}

export default function Text({
    white = false,
    style = {},
    children,
}: Props) {
    const { t, i18n } = useTranslation();
    const isChinese = i18n.language === 'zhTW' || i18n.language === 'cn';
    return <StyledText isChinese={isChinese} white={white} style={style}>
        {children}
    </StyledText>
}